import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../../data/mock';

const FloatingButtons = () => {
  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <a
        href={contactInfo.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 group relative"
        title="WhatsApp Us"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="absolute right-full mr-3 bg-green-500 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          WhatsApp Us
        </span>
      </a>

      {/* Call Button */}
      <a
        href={`tel:${contactInfo.phone}`}
        className="w-14 h-14 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 group relative"
        title="Call Support"
      >
        <Phone className="w-6 h-6" />
        <span className="absolute right-full mr-3 bg-blue-500 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          Call Support
        </span>
      </a>
    </div>
  );
};

export default FloatingButtons;
